import type { FullComposeViewState } from 'owa-calendar-compose-types';
import { action } from 'satcheljs/lib/legacy';

/**
 * Shows/hide the editor ribbon
 * @param {FullComposeViewState} viewState The full compose viewState
 * @param {boolean} isShown Whether show the ribbon
 */
export default action('setIsRibbonShown')(function showEditorRibbon(
    viewState: FullComposeViewState,
    isShown: boolean
) {
    viewState.isRibbonShown = isShown;
});
